import React from 'react';
import {
  getQuizDisplayTitle,
  getQuizDisplayTheme,
  type QuizCardTextLike,
} from '../utils/quizDisplayTitle';

type Props = {
  quiz: QuizCardTextLike;
  language: string;
};

/** Play screen: quiz title with optional centered theme line below (when set). */
const QuizPlayPageHeading: React.FC<Props> = ({ quiz, language }) => {
  const title = getQuizDisplayTitle(quiz, language);
  const theme = getQuizDisplayTheme(quiz, language);

  return (
    <div className="quiz-page-header__heading">
      <h1 className="quiz-page-header__title mb-0">{title}</h1>
      {theme ? <p className="quiz-page-header__theme small text-muted mb-0">{theme}</p> : null}
    </div>
  );
};

export default QuizPlayPageHeading;
